import { DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

export const DealerGroupColumns = (
    hoveredRow,
    setShowModal,
    setSelectedRowKeys,
    setParams,
    params,
) => {
    const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};
    const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
    const isSystemUser = [1, 2, 3].includes(loggedInUser?.role_value);

    return [
        {
            title: "No",
            dataIndex: "GroupNo",
            key: "GroupNo",
            hidden: !isSystemUser,
            sorter: (a, b) => a?.GroupNo - b?.GroupNo,
            sortIcon: () => (
                <SortIcon
                    sortOrder={modParams.order}
                    columnKey="GroupNo"
                    sortBy={modParams.sort_by}
                />
            ),
            onHeaderCell: () => ({
                onClick: () =>
                    setParams((prev) => ({
                        ...modParams,
                        sort_by: "GroupNo",
                        order: modParams.order === "desc" ? "asc" : "desc",
                    })),
            }),
        },
        {
            title: "Name",
            dataIndex: "GroupName",
            key: "GroupName",
            sorter: (a, b) => () => { },
            sortIcon: () => (
                <SortIcon
                    sortOrder={modParams.order}
                    columnKey="GroupName"
                    sortBy={modParams.sort_by}
                />
            ),
            onHeaderCell: () => ({
                onClick: () =>
                    setParams((prev) => ({
                        ...modParams,
                        sort_by: "GroupName",
                        order: modParams.order === "desc" ? "asc" : "desc",
                    })),
            }),
        },
        {
            title: "Description",
            dataIndex: "GroupDesc",
            key: "GroupDesc",
            sorter: (a, b) => () => { },
            sortIcon: () => (
                <SortIcon
                    sortOrder={modParams.order}
                    columnKey="GroupDesc"
                    sortBy={modParams.sort_by}
                />
            ),
            onHeaderCell: () => ({
                onClick: () =>
                    setParams((prev) => ({
                        ...modParams,
                        sort_by: "GroupDesc",
                        order: modParams.order === "desc" ? "asc" : "desc",
                    })),
            }),
        },
        {
            title: "Discount",
            dataIndex: "Discount",
            key: "Discount",
            sorter: (a, b) => a.Discount - b.Discount,
            render: (value) => `${value} %`,
            sortIcon: () => (
                <SortIcon
                    sortOrder={modParams.order}
                    columnKey="Discount"
                    sortBy={modParams.sort_by}
                />
            ),
            onHeaderCell: () => ({
                onClick: () =>
                    setParams((prev) => ({
                        ...modParams,
                        sort_by: "Discount",
                        order: modParams.order === "desc" ? "asc" : "desc",
                    })),
            }),
        },
        {
            title: "",
            fixed: "right",
            width: 0,
            align: "center",
            render: (text, record, rowIndex) =>
                hoveredRow === rowIndex ? (
                    <div className="absolute top-2 right-5">
                        <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
                            <Tooltip title="Edit">
                                <div className="hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] mr-1 ">
                                    <Link
                                        to={`/dealer-group/edit/${record?.GroupNo}`}
                                        onClick={(e) => e.stopPropagation()}
                                        className=" hover:text-[#636262ee]"
                                    >
                                        <FontAwesomeIcon
                                            icon={faEdit}
                                            className="!text-[#50565e]"
                                        />
                                    </Link>
                                </div>
                            </Tooltip>
                            <Tooltip title="Delete">
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setShowModal(true);
                                        setSelectedRowKeys([record?.GroupNo]);
                                    }}
                                    className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
                                >
                                    <DeleteOutlined />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                ) : null,
        },
    ];
};